export default function calculateDuration(startTime: string, endTime: string) {
    const [startHours, startMinutes] = startTime.split(":").map(Number);
    const [endHours, endMinutes] = endTime.split(":").map(Number);
    const durationMinutes =
        endHours * 60 + endMinutes - (startHours * 60 + startMinutes);
    return durationMinutes;
}
